<template>
  <div>
    <!--Header-->
    <div>
      <main-header />
    </div>
    <!--AdminPanel-->
    <div class="section">
      <div class="columns">
        <!--Item's column-->
        <div class="column is-one-third has-background-warning">
          <!--ID-->
          <p>Item's facts</p>
          <div class="columns is-gapless is-mobile">
            <div class="column">
              <input class="input is-size-7" type="text" placeholder="id" />
            </div>
            <div class="column">
              <button class="button is-size-7 is-fullwidth">New</button>
            </div>
            <div class="column">
              <button class="button is-size-7 is-fullwidth">Edit</button>
            </div>
            <div class="column">
              <button class="button is-size-7 is-fullwidth">Delete</button>
            </div>
          </div>
          <!--Name-->
          <div class="donja-margina">
            <input class="input is-size-7" type="text" placeholder="name" />
          </div>
          <!--Description-->
          <div class="donja-margina">
            <textarea class="textarea is-size-7" placeholder="Description"></textarea>
          </div>
          <!--Image-->
          <div>
            <div class="columns">
              <div class="column">
                <button class="button is-size-7 is-fullwidth">Choose image</button>
                <input class="input is-size-7" type="text" placeholder="white area coefficient" />
              </div>
              <div class="column">
                <figure class="image is-64x64">
                  <img />
                </figure>
              </div>
            </div>
          </div>
          <!--Item's facts-->
          <div class="columns">
            <div class="column">
              <input class="input is-size-7" type="text" placeholder="Item's COI" />
            </div>
            <div class="column">
              <input class="input is-size-7" type="text" placeholder="Item's Global Price" />
            </div>
          </div>
          <!--Manufacturer's facts-->
          <div>
            <p>Manufacturer's facts</p>
            <div class="columns">
              <div class="column">
                <treeselect
                  class="is-size-7"
                  name="manufacturers"
                  placeholder="Manufacturers"
                  :multiple="true"
                  :searchable="true"
                  :disabled="false"
                  :open-on-click="true"
                  :open-on-focus="true"
                  :clear-on-select="true"
                  :close-on-select="true"
                  :always-open="false"
                  :append-to-body="false"
                  :options="manufacturers"
                  :limit="3"
                  :max-height="400"
                  :value="filteredManufacturerIds"
                  @input="updateFilteredManufacturerIds"
                />
              </div>
              <div class="column is-one-fifth">
                <router-link class="button is-size-7" to="/admin/manufacturers">...</router-link>
              </div>
            </div>
          </div>
          <!--Supplier's facts-->
          <div>
            <p class="gornja-margina">Supplier's facts</p>
            <div class="columns">
              <div class="column">
                <treeselect
                  class="is-size-7"
                  name="suppliers"
                  placeholder="Suppliers"
                  :multiple="true"
                  :searchable="true"
                  :disabled="false"
                  :open-on-click="true"
                  :open-on-focus="true"
                  :clear-on-select="true"
                  :close-on-select="true"
                  :always-open="false"
                  :append-to-body="false"
                  :options="suppliers"
                  :limit="3"
                  :max-height="400"
                  :value="filteredManufacturerIds"
                  @input="updateFilteredManufacturerIds"
                />
              </div>
              <div class="column is-one-fifth">
                <button class="button is-size-7">...</button>
              </div>
            </div>
            <!--SupplierItems-->
            <div>
              <div class="columns">
                <div class="column">
                  <input class="input is-size-7" type="text" placeholder="Item's Importance" />
                </div>
                <div class="column">
                  <input class="input is-size-7" type="text" placeholder="Item's Priority" />
                </div>
              </div>
              <div class="columns">
                <div class="column">
                  <input class="input is-size-7" type="text" placeholder="Item's VAT class" />
                </div>
                <div class="column">
                  <input class="input is-size-7" type="text" placeholder="Item's Promo level" />
                </div>
              </div>
              <div class="columns">
                <div class="column">
                  <input class="input is-size-7" type="text" placeholder="Items on stock" />
                </div>
                <div class="column">
                  <input class="input is-size-7" type="text" placeholder="Item's recommended price" />
                </div>
              </div>
              <div class="columns">
                <div class="column">
                  <div class="columns">
                    <div class="column">
                      <treeselect
                        class="is-size-7"
                        name="manufacturers"
                        placeholder="Discount groups"
                        :multiple="true"
                        :searchable="true"
                        :disabled="false"
                        :open-on-click="true"
                        :open-on-focus="true"
                        :clear-on-select="true"
                        :close-on-select="true"
                        :always-open="false"
                        :append-to-body="false"
                        :options="manufacturers"
                        :limit="3"
                        :max-height="400"
                        :value="filteredManufacturerIds"
                        @input="updateFilteredManufacturerIds"
                      />
                    </div>
                    <div class="column is-one-fifth">
                      <button class="button is-size-7">...</button>
                    </div>
                  </div>
                </div>
                <div class="column is-one-fifth">
                  <input class="input is-size-7" type="text" placeholder="Discount value" />
                </div>
              </div>
            </div>
          </div>
          <!--Save-->
          <div>
            <p class="gornja-margina"></p>
            <button class="button gornja-margina is-large">Save</button>
          </div>
        </div>
        <!--Types Tree and List-->
        <div class="column has-background-info">
          <p>Types Tree</p>
          <!--Select categories-->
          <div>
            <treeselect
              class="input my-categories"
              name="categories"
              placeholder="Traži po kategoriji..."
              :multiple="true"
              :clearable="true"
              :searchable="true"
              :disabled="false"
              :open-on-click="true"
              :open-on-focus="true"
              :clear-on-select="true"
              :close-on-select="true"
              :always-open="false"
              :append-to-body="false"
              :options="categories"
              :limit="3"
              :max-height="400"
              v-model="selectedCategoryId"
            />
          </div>
          <div class="is-half has-background-success">
            <product-list />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MainHeader from "../MainHeader";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import ProductList from "../ProductList";

import { mapState } from "vuex";

export default {
  name: "Admin",
  components: { MainHeader, Treeselect, ProductList },

  computed: {
    ...mapState(["manufacturers"]),
  },

  created() {
    this.$store.dispatch("getManufacturers");
  }
};
</script>

<style scoped>
.donja-margina {
  margin-bottom: 10px;
}
.gornja-margina {
  margin-top: 15px;
}
</style>